import { CITY } from '@city'
import { useEffect, useState } from 'react'
import {
  fetchLineStatuses,
  type LineStatusEntry,
} from '../components/stationPage/fetchLineStatuses'

/**
 * Live TfL status of one line for the line view's status row. `undefined`
 * while loading or when the city has no live status (the row is hidden);
 * `null` once fetched with nothing reported — the row reads Good service,
 * the same fail-safe default as the station page.
 */
export function useLineStatus(lineId: string | null): LineStatusEntry | null | undefined {
  const [status, setStatus] = useState<{ lineId: string; entry: LineStatusEntry | null } | null>(
    null,
  )
  useEffect(() => {
    if (lineId === null || !CITY.lineStatus) return
    let cancelled = false
    void fetchLineStatuses([lineId]).then((statuses) => {
      if (!cancelled) setStatus({ lineId, entry: statuses[lineId] ?? null })
    })
    return () => {
      cancelled = true
    }
  }, [lineId])
  return status !== null && status.lineId === lineId ? status.entry : undefined
}
